import React from "react";
import styled from "styled-components";

/* Wrapper with system font fallback */
const ContentWrapper = styled.div`
  font-family: "Noto Sans", "Segoe UI", "Helvetica Neue", Arial, sans-serif;
  color: #111827;
`;

/* Titles */
const WelcomeTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #183967;
`;

const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  margin: 15px 0 10px;
  color: #183967;
`;

/* Paragraph */
const Paragraph = styled.p`
  color: #111827;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.75;
  letter-spacing: 0;
  margin-bottom: 12px;
  text-align: justify;
`;

/* Bullet List */
const BulletList = styled.ul`
  list-style: none;
  padding-left: 0;
  margin: 10px 0 15px;
  color: #111827;
`;

const BulletItem = styled.li`
  font-size: 15px;
  font-weight: 400;
  line-height: 1.65;
  margin-bottom: 8px;
  padding-left: 22px;
  position: relative;
  text-align: justify;

  &:before {
    content: "\\2022";
    position: absolute;
    left: 0;
    color: #183967;
    font-weight: bold;
  }

  strong {
    color: #183967;
    font-weight: 700;
  }
`;

/* Table */
const TableWrapper = styled.div`
  background: #ffffff;
  border-radius: 18px;
  padding: 18px;
  margin: 16px 0 22px;
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.06);
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  min-width: 680px;
  border-collapse: separate;
  border-spacing: 0;

  tbody tr:nth-child(even) td {
    background: #f7f9fb;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
`;

const Th = styled.th`
  background: #dce9fb;
  text-align: left;
  padding: 13px 16px;
  font-size: 13px;
  font-weight: 700;
  color: #1f3556;

  &:first-child {
    border-radius: 8px 0 0 8px;
  }

  &:last-child {
    border-radius: 0 8px 8px 0;
  }
`;

const Td = styled.td`
  padding: 13px 16px;
  font-size: 13px;
  color: #111827;
  border-bottom: 1px solid #d8dee6;
  line-height: 1.45;
`;

/* Component */
const TargetGroupsContent = () => {
  return (
    <ContentWrapper>
      <WelcomeTitle>Target Groups</WelcomeTitle>

      <Paragraph>
        The prime mandate of NMDFC is to provide concessional finance to the Minorities for
        self-employment/income generation activities. As per the National Commission of
        Minorities Act, 1992, the notified Minorities are Muslims, Christians, Sikhs,
        Buddhists, and Parsis. Subsequently, the Jain community was also added to the list
        of notified Minority Communities in January 2014.
      </Paragraph>

      <Paragraph>
        At present, families having an annual income up to Rs. 3.00 lakh are eligible under
        the NMDFC schemes. As a special initiative of NMDFC, the annual family income
        eligibility limit has been enhanced to Rs. 8.00 lakh with effect from November 2020,
        by adopting the "Creamy Layer" criterion currently followed among the OBC community
        by the Government of India.
      </Paragraph>

      <SectionTitle>Channels To Reach the Target Groups</SectionTitle>

      <Paragraph>
        NMDFC has the following two channels to reach the target groups:
      </Paragraph>

      <BulletList>
        <BulletItem>
          <strong>State Channelising Agencies (SCAs):</strong> It is the main channel.
          State Channelising Agencies (SCAs) are nominated by the respective State
          Governments. At present, NMDFC has 39 operational Channelising Agencies, and
          their break-up is given below:
        </BulletItem>
      </BulletList>

      <TableWrapper>
        <Table>
          <thead>
            <tr>
              <Th>S.No.</Th>
              <Th>Target Groups</Th>
              <Th>No.</Th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <Td>01</Td>
              <Td>Minority Development & Finance Corporation</Td>
              <Td>16 Nos.</Td>
            </tr>
            <tr>
              <Td>02</Td>
              <Td>State SC/ST Development Corporations</Td>
              <Td>5 Nos.</Td>
            </tr>
            <tr>
              <Td>03</Td>
              <Td>State Backward Classes Development Corporations</Td>
              <Td>7 Nos.</Td>
            </tr>
            <tr>
              <Td>04</Td>
              <Td>State Women's Development Corporations</Td>
              <Td>2 Nos.</Td>
            </tr>
            <tr>
              <Td>05</Td>
              <Td>Handloom & Handicrafts Corporations</Td>
              <Td>1 Nos.</Td>
            </tr>
            <tr>
              <Td>06</Td>
              <Td>
                Other Agencies (Cooperative Banks, Industrial Development Corporations, etc.)
              </Td>
              <Td>8 Nos.</Td>
            </tr>
            <tr>
              <Td>-</Td>
              <Td><strong>Total</strong></Td>
              <Td><strong>39 Nos.</strong></Td>
            </tr>
          </tbody>
        </Table>
      </TableWrapper>

      <BulletList>
        <BulletItem>
          <strong>Non-Governmental Organisations (NGOs):</strong> The services of selected
          Non Governmental Organisations (NGOs) are availed for reaching the Target Groups
          through SHGs. Such an NGO should be more than three years old, apolitical,
          financially sound, and engaged in socio-economic activities with a minimum of one
          year of experience in thrift and credit.
        </BulletItem>
      </BulletList>
    </ContentWrapper>
  );
};

export default TargetGroupsContent;
